/* eslint-disable no-param-reassign, prefer-destructuring, prefer-rest-params, func-names */
export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      (function (c, l, a, r, i) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }

        const t = l.createElement(r) as HTMLScriptElement
        t.async = true
        t.src = `https://www.clarity.ms/tag/${i}`

        const y = l.getElementsByTagName(r)[0]

        if (y && y.parentNode) {
          y.parentNode.insertBefore(t, y)
        }
        c[a]('consent')
      }(window, document, 'clarity', 'script', toolId))
    },
  })
}
